import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledCustomers } from "./customers.styled";
import { SEARCH_TABLE_STYLE } from "./customers.constants";
import { useCustomerOptions } from "./customers.data";
import { useCustomerStructures } from "./useCustomerStructures";
import { useCustomersBrowse } from "./useCustomersBrowse";
import { useCustomersNavigation } from "./useCustomersNavigation";

/**
 * Customers browse page: search filters, sortable table, and optional row selection for document flows.
 */
function Customers() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useCustomerStructures();
  const browse = useCustomersBrowse();
  const navigation = useCustomersNavigation();
  const customerOptions = useCustomerOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledCustomers>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.accountSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          height={100}
          animation="wave"
          sx={skeletonSx}
        />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={customerOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          height={150}
          animation="wave"
          sx={skeletonSx}
        />
      )}
    </StyledCustomers>
  );
}

export default Customers;
